export default __webpack_public_path__ + "static/tasks-9c0953ae8d226f2847b1db513497d2d7.png";